export const dataAddComment = {
	title: "Add New Note",
	inputPlaceholder: "Add comments",
	buttonText: "Add comment",
};
